var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-reality-currency"},[_vm._v(" You have "),_c('b',{class:_vm.resourceClass()},[_vm._v(" "+_vm._s(_vm.currencyValue)+" ")]),_vm._v(" "+_vm._s(_vm.currencyName)+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }